import * as React from "react";
import Avatar, { AvatarProps } from "@mui/material/Avatar";
import { Session } from "../../types/types";

/**
 * @ignore - internal component.
 */

export interface SessionAvatarProps extends AvatarProps {
  session: Session;
}

export function SessionAvatar(props: SessionAvatarProps) {
  const { session, ...rest } = props;
  return (
    <Avatar
      src={session.user?.image || String(session.user?.name[0])}
      alt={session.user?.name || session.user?.email || ""}
      {...rest}
      sx={{
        color: "#FFFFFF",
        backgroundColor: "#00263A",
        border: "2px solid #44D62C",
      }}
    />
  );
}
